module.exports = __webpack_public_path__ + "img/drink.a70afc56.svg";